<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   [searchText]="searchText"
   [showCreate]="extensionGroupPrivileges?.canAdd"
   [hideHeader]="hideHeader"
   (create)="onCreate()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
>
   <ndt-register-quick-filter> </ndt-register-quick-filter>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="name" width="4">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="extensionGroupName-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="name"
               >Name <mat-icon class="mat-icon-sort">{{ getSort('name') }}</mat-icon>
            </th>
            <td lcs-cell *lcsCellDef="let extensionGroup">
               <a [routerLink]="getRouterLink(extensionGroup.extensionGroupId)">
                  {{ extensionGroup.name }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="description" width="4">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="extensionGroupDescription-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="description"
               >Description <mat-icon class="mat-icon-sort">{{ getSort('description') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let extensionGroup">
               <a [routerLink]="getRouterLink(extensionGroup.extensionGroupId)">
                  {{ extensionGroup.description }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="created" width="4">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="extensionGroupCreated-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="createDate"
               >Created <mat-icon class="mat-icon-sort">{{ getSort('createDate') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let extensionGroup">
               <a [routerLink]="getRouterLink(extensionGroup.extensionGroupId)">
                  {{ extensionGroup.createDate | date : 'MM/dd/yyyy' }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="extensions" width="2">
            <th
               class="register-column-header numeric"
               lcs-header-cell
               *lcsHeaderCellDef
               id="extensionIssues-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="extensionGroupCount"
               >Extensions <mat-icon class="mat-icon-sort">{{ getSort('extensionGroupCount') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let extensionGroup" class="numeric">
               <a [routerLink]="getRouterLink(extensionGroup.extensionGroupId)">
                  {{ extensionGroup.extensionGroupExtensionCount }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="extensionGroupActionsMenu" width="1">
            <th lcs-header-cell *lcsHeaderCellDef id="extension-group-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let extensionGroup">
               <button
                  type="button"
                  aria-label="ExtensionGroup Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="extensionGroupRolesMenu"
                  id="extension-group-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               <mat-menu #extensionGroupRolesMenu="matMenu">
                  <a mat-menu-item [routerLink]="getRouterLink(extensionGroup.extensionGroupId)"> Details </a>
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
